import { Truck, Wrench } from "lucide-react";

// BUILDER vs PARTS TRUCK (his ask, Batch 4): the truck's existing role — the same one a Build job picks its truck by.
// Every truck starts as a parts truck; "Switch to Builder" on the truck page (with its PO) makes it a builder.
export function TruckRoleTag({ role, testid, size = "sm" }) {
  const builder = role === "builder";
  const big = size === "md";
  return (
    <span data-testid={testid} data-role={builder ? "builder" : "donor"}
      title={builder ? "Builder — designated for recon" : "Parts — not a builder (trucks and equipment)"}
      className={`inline-flex items-center gap-1 rounded-md border font-mono font-bold uppercase tracking-wide w-fit ${big ? "text-[11px] px-2 h-6" : "text-[9px] px-1.5 h-5"} ${builder ? "border-indigo-300 bg-indigo-600 text-white" : "border-slate-300 bg-white text-slate-600"}`}>
      {builder ? <Wrench className={big ? "w-3.5 h-3.5" : "w-3 h-3"} /> : <Truck className={big ? "w-3.5 h-3.5" : "w-3 h-3"} />}
      {builder ? "Builder" : "Parts"}
    </span>
  );
}

// Builders · Parts · All — tap only, each with its count, counted on everything else that is on.
export function TruckRoleFilter({ value, counts, onPick, testid = "role-filter" }) {
  const opts = [["builder", "Builders"], ["donor", "Parts"], ["", "All"]];
  const n = (k) => (counts ? counts[k || "all"] : null);
  return (
    <div data-testid={testid} role="group" aria-label="Builders or parts" className="inline-flex rounded-full border border-slate-300 bg-white p-0.5 self-center">
      {opts.map(([k, label]) => {
        const on = (value || "") === k;
        return (
          <button key={label} type="button" data-testid={`${testid}-${k || "all"}`} aria-pressed={on} onClick={() => onPick(k)}
            className={`rounded-full px-3 h-8 text-xs font-semibold transition-colors ${on ? "bg-slate-800 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
            {label}{n(k) != null && <span className={`ml-1 tabular-nums ${on ? "text-slate-300" : "text-slate-400"}`}>{n(k)}</span>}
          </button>
        );
      })}
    </div>
  );
}
